import { DEFAULT_ENVIRONMENT_DATA } from '@cengage/cap-portal-environment-lib-react';
import type { Config } from '@cafe/core';

import { CoreDataEnvironmentKeys } from './services/portal-core-data/portal-core-data.service';
import { ClientInteractionEnvironmentKeys } from './services/cap-client-interaction.service';

export const environmentOptions = {
  environments: DEFAULT_ENVIRONMENT_DATA,
  overrides: {
    environments: [
      {
        name: 'staging',
        logoutPageHost: 'stage-account.cengage.com',
        errorLoggingApiKey: '3iuUGh9eNQaWnooHumiBMsvWdfvZKztPUFDdvthG',
        [CoreDataEnvironmentKeys.CoreDataEndpoint]:
          'https://cap-portal-core-data-staging01.cengage.info/v1',
        [CoreDataEnvironmentKeys.CoreDataCacheEnabled]: 'true',
        [ClientInteractionEnvironmentKeys.ClientInteractionEndpoint]:
          'https://cap-client-interaction-staging01.cengage.info/v1',
      },
      {
        name: 'production',
        logoutPageHost: 'account.cengage.com',
        errorLoggingApiKey: 'hKcjN4KagLQtNRwRs784eaebUstXYiAkgsLtEWBt',
        [CoreDataEnvironmentKeys.CoreDataEndpoint]:
          'https://cap-portal-core-data-production01.cengage.info/v1',
        [CoreDataEnvironmentKeys.CoreDataCacheEnabled]: 'true',
        [ClientInteractionEnvironmentKeys.ClientInteractionEndpoint]:
          'https://cap-client-interaction-production01.cengage.info/v1',
      },
    ],
    whitelistedDomains: [
      'cap-portal-core-data-staging01.cengage.info',
      'cap-portal-core-data-production01.cengage.info',
      'cap-client-interaction-staging01.cengage.info',
      'cap-client-interaction-production01.cengage.info',
    ],
  },
  applicationName: 'portal',
};

export const cafeOptions: Partial<Config> = {
  productPlatform: 'analytics-portal',
  fetchIpAddress: true,
  recordViewingTime: false,
  logErrorsToService: true,
  bufferInterval: 60000,
  maxBufferSize: 500,
  profileSubmissionDelay: 5000,
  installOnUnloadHandler: true,
  attemptCompletionOnClose: true,
  sendUnloadEventOnHide: false,
};

export const DEFAULT_NAVIGATION_EVENT_CATEGORY = 'ROUTER_NAVIGATION';
export const DATE_FORMAT = 'MMM d, y, h:mm a';
